import styled from 'styled-components';
import { Switch } from 'antd';

export const StyledActionBar = styled.div`
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);
`;

export const StyledSwitch = styled(Switch)`
  &.ant-switch {
    background-image: none;
    background-color: ${({ unCheckedColor }) => unCheckedColor || '#bfbfbf'} !important;
  }
  &.ant-switch-checked {
    background-color: ${({ checkedColor }) => checkedColor || '#1890ff'} !important;
  }
  .ant-switch-inner{
    display: flex;
  }
`;